import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import type { Run } from '../../api/runs/interface';
import type { StoreState } from '../store';
import { actions as RunActions } from './logic';

export interface UseRunHookState {
  runs: Run[];
  selectedRun: Run | null;
}

export interface UseRunHookHandler {
  fetchRuns(): void;
  setSelectedRun(run: Run | null): void;
}

const useRunHook = (
  dossierId: string
): [UseRunHookState, UseRunHookHandler] => {
  const dispatch = useDispatch();
  const runs = useSelector((s: StoreState) => s['runs'].runs[dossierId]);
  const selectedRun = useSelector(
    (s: StoreState) => s['runs'].selected_runs[dossierId]
  );
  const handler = React.useMemo(
    () => ({
      fetchRuns: () => {
        dispatch(RunActions.runs(dossierId));
      },
      setSelectedRun: (run: Run | null) => {
        dispatch(
          RunActions.setSelectedRun({
            dossier_id: dossierId,
            run,
          })
        );
      },
    }),
    [dossierId]
  );
  return [
    {
      runs,
      selectedRun,
    },
    handler,
  ];
};

export default useRunHook;
